<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch,computed } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import OrderMedicineComponent from '../../../Common/OrderMedicineComponent.vue';
import PackRefundComponent from "../../../Common/PackRefundComponent.vue";
import config from "../../../../config.js";
import { errorAlert,confirmAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { useOrderStore } from '../../../../stores/order';
import HelpAction from '../../../../compositions/HelpAction.vue';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    },
    updateComplete:{
        type:Function,
    }
})

const refundPackDialog = ref(null);
const refundPackDialogIdentityId = ref(0);
const clickRefundPackButton = (pharmacyPackId) => {
  refundPackDialog.value.showRefundPackEditDialog(pharmacyPackId);
}
const listHeight = ref(0);
const headerRef = ref();
const submitRef = ref();
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - document.getElementById('order_header').clientHeight - headerRef.value.clientHeight - 5;
    if (typeof submitRef.value !== 'undefined' && isEditedCheck()) {
      listHeight.value -= (submitRef.value.clientHeight - document.getElementById('footer').clientHeight - 5);
    }
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
}

const { isVisible,identityId } = toRefs(props);
const listOrderPackRef = ref();
const searchWord = ref('');
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const orderFields = ref([
  {field_name: '採用品', field_key: 'product_name', width: '15%', align: 'text-left', sorted:true},
  {field_name: '', field_key: 'pack_status', width: '5%', align: 'text-center', sorted:true},
  {field_name: '取引先', field_key: 'pack_to_pharmacy', width: '5%', align: 'text-left', sorted:true,is_join:true},
  {field_name: '包装単位', field_key: 'package_label', width: '15%', align: 'text-left', sorted:false,is_join:true},
  {field_name: '取引数量', field_key: 'number', width: '5%', align: 'text-center',is_join:true},
  {field_name: '取引単価', field_key: 'unit_price', width: '5%', align: 'text-center',is_join:true},
  {field_name: '', field_key: 'edit_pack_submit_wait', width: '40%', align: 'text-center'},
  {field_name: '', field_key: 'action_pack_submit_wait', width: '10%', align: 'text-center'},
]);
const orderOptionFields = reactive({
  'search_word' : searchWord.value,
  'page_size' : 30,
  'is_pack': 1,
});
const listSearch = (force = false,delay=0) => {
  orderOptionFields.search_word = searchWord.value;
  if (force == false) {
    listOrderPackRef.value.resetItem(delay);
  } else {
    listOrderPackRef.value.resetForceItem(delay);
  }
}
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const storeReset = () => {
  order.reset_data('is_pack_submit_wait');
}
const cancel = () => {
  storeReset();
}
watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    listSearch();
    setTimeout(changeListHeight,100);
  }
})
watch(identityId,(newValue, oldValue) => {
  listSearch(true);
})

const domComplete = () => {
  order.order_pack_count = listOrderPackRef.value.getItemAllCount();
}
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
})
onMounted(() => {
  setTimeout(changeListHeight,100);
  listSearch();
  window.addEventListener('resize', changeListHeight);
});
const isEditedCheck = () => {
  return (order.edit_pack_submit_wait_data.length > 0 ? true : false);
}
const isEdited = computed(() => {
  setTimeout(changeListHeight,100);
  return isEditedCheck();
});
const isLoadingDialog = ref(false);
const updatePackSubmitWaitConfirm = async () => {
  let result = await confirmAlert('編集した内容を登録しますか？<br>登録すると元に戻せませんので、内容をご確認ください。');
  if (result.isConfirmed) {
    await updatePackSubmitWait();
  }
}
const updatePackSubmitWait = async () => {
  let params = [];
  //エラーチェック
  for (let i=0;i<order.edit_pack_submit_wait_data.length;i++) {
    order.edit_pack_submit_wait_data[i].is_error = false;
    order.edit_pack_submit_wait_data[i].error_message = '';
    if (order.edit_pack_submit_wait_data[i].pack_status == config.PACK_STATUSES['承認待ち']) {
      if (order.edit_pack_submit_wait_data[i].is_submitted) {
        //取引の合計が変わってしまう場合はエラー
        let total_number = 0;
        for (let j=0;j<order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits.length;j++) {
          total_number += order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits[j].number;
        }
        if (total_number != order.edit_pack_submit_wait_data[i].total_number) {
          order.edit_pack_submit_wait_data[i].is_error = true;
          order.edit_pack_submit_wait_data[i].error_message = '取引数量が変更されています。';
        }
      }
    } else {
      if (order.edit_pack_submit_wait_data[i].is_submitted) {
        //全てにロット番号と有効期限、数量が入っているかチェック
        for (let j=0;j<order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits.length;j++) {
          if (order.edit_pack_submit_wait_data[i].medicine_type != config.NON_MEDICINE_TYPES['OTC・雑貨'] && !order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits[j].lot_no) {
            order.edit_pack_submit_wait_data[i].is_error = true;
            order.edit_pack_submit_wait_data[i].error_message += 'ロット番号は必須です。';
          }
          if (order.edit_pack_submit_wait_data[i].medicine_type != config.NON_MEDICINE_TYPES['OTC・雑貨'] && !order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits[j].expire_date) {
            order.edit_pack_submit_wait_data[i].is_error = true;
            order.edit_pack_submit_wait_data[i].error_message += '有効期限は必須です。';
          }
          if (!order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits[j].number) {
            order.edit_pack_submit_wait_data[i].is_error = true;
            order.edit_pack_submit_wait_data[i].error_message += '数量は必須です。';
          }
        }
        //数量に変更がないかチェック
        let total_number = 0;
        for (let j=0;j<order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits.length;j++) {
          total_number += order.edit_pack_submit_wait_data[i].pharmacy_pack_submit_waits[j].number;
        }
        if (total_number != order.edit_pack_submit_wait_data[i].total_number) {
          order.edit_pack_submit_wait_data[i].is_error = true;
          order.edit_pack_submit_wait_data[i].error_message += '取引数量が変更されています。';
        }
      }
    }
    order.update_pack_submit_wait(order.edit_pack_submit_wait_data[i]);
  }
  let isError = false;
  for (let i=0;i<order.edit_pack_submit_wait_data.length;i++) {
    if (order.edit_pack_submit_wait_data[i].is_error) {
      isError = true;
      break;
    }
  }
  if (isError) {
    errorAlert('エラーがあります。入力データをご確認ください。');
    return;
  }
  for (let i=0;i<order.edit_pack_submit_wait_data.length;i++) {
    if (order.edit_pack_submit_wait_data[i].is_submitted == false && order.edit_pack_submit_wait_data[i].is_canceled == false) {
      continue;
    }
    params.push(order.edit_pack_submit_wait_data[i]);
  }
  if (params.length == 0) {
    errorAlert('登録するデータがありません。チェックが付いているかご確認ください。');
    return;
  }
  assignmentList.splice(0);
  isLoadingDialog.value = true;
  try {
    const response = await axios(props.apis.pharmacy_order_pack_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.updateComplete !== 'undefined') {
        props.updateComplete();
      }
      for (let i=0;i<response.data.pharmacy_pack_wait_list.length;i++) {
        assignmentList.push(response.data.pharmacy_pack_wait_list[i]);
      }
      storeReset();
      listSearch(false,config.LIST_DELAY);
      if (assignmentList.length > 0) {
        showAssignmentListDialog();
      }
    }
  } finally {
    isLoadingDialog.value = false;
  }
}
const onChangePackSubmitWait = (item,packStatus,action) => {
  //取りあえず何もしない
}
const isAssignmentListDialog = ref(false);
const assignmentList = reactive([]);
const showAssignmentListDialog = () => {
  isAssignmentListDialog.value = true;
}
const closeAssignmentListDialog = () => {
  isAssignmentListDialog.value = false;
}
</script>

<style scoped>
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="order_pack_submit_list_help"
    ></help-action>
  </div>
  <div ref="headerRef" class="w-full flex items-center justify-end p-2 bg-gray-100 rounded">
    <div class="mb-2 mt-1">
    <search-box
        :search-word="searchWord"
        :on-change="onSearchWordChange"
        :on-enter="onSearchWordEnter"
        place-Packer="採用品名を入力"
    ></search-box>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listOrderPackRef"
      :table-fields="orderFields"
      :option-fields="orderOptionFields"
      :api-url="apis.pharmacy_stock_pack_list"
      :height="listHeight + 'px'"
      :handler="handler"
      :is-cell-join="true"
      :dom-complete="domComplete"
    >
    <template v-slot:item="slotProps">
      <order-medicine-component
        :apis="apis"
        type="is_pack"
        :pharmacy-wholesalers="pharmacyWholesalers"
        :identity-id="slotProps.item.id"
        :item="slotProps.item"
        :fields="orderFields"
        join-field-key="pharmacy_stocks"
        :pack-submit-wait-editChange="onChangePackSubmitWait"
      ></order-medicine-component>
    </template>
    </custom-list>
    <div ref="submitRef" v-show="isEdited" class="fixed bottom-0 right-0 w-full flex items-center justify-end flex-wrap p-2 bg-gray-100 rounded">
      <a href="javascript:void(0)" @click="cancel" class="flex py-2.5 px-5 m-2 text-base font-medium text-white focus:outline-none bg-red-800 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">キャンセル</a>
      <button type="button" @click="updatePackSubmitWaitConfirm" class="py-2.5 px-5 m-2　text-base font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録</button>
    </div>
  </div>
</div>
<modal-dialog
  :is-visible="isAssignmentListDialog"
  width="40%"
  :close="closeAssignmentListDialog"
>
  <template v-slot:header>
    譲受譲渡書
  </template>
  <template v-slot:default>
  <div class="mb-2">
    <p class="text-red-500">※間違えて閉じてしまった場合は、受発注履歴からでも印刷出来ます。</p>
    <table class="w-full">
      <tr v-for="assignmentData in assignmentList" :key="assignmentData.id" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-3/4 md:text-sm">
          <div class="flex flex-col">
            <div class="mb-1">
              取引先：{{ assignmentData.to_pharmacy.pharmacy_name }}({{ assignmentData.medicine_group_name }})
            </div>
            <div class="mb-1">
              譲受譲渡日：{{ assignmentData.assignment_date }}
            </div>
            <div class="mb-1">
              {{ assignmentData.tax_total_type_label }}　小数点の扱い：{{ assignmentData.amount_float_type_label }}
            </div>
          </div>
        </th>
        <td class="block py-3 text-sm md:table-cell md:w-1/4 md:px-3 md:py-2">
          <div class="mb-2"><a :href="'/pdf/assignment/?id=' + assignmentData.id" target="_blank" class="block text-center py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-red-400 rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">譲受譲渡書</a></div>
          <div><a href="javascript:void(0)" class="text-center block py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-blue-400 rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" @click="clickRefundPackButton(assignmentData.id)">小分け金額調整</a></div>
        </td>
      </tr>
    </table>
  </div>
  </template>
</modal-dialog>
<pack-refund-component
  ref="refundPackDialog"
  :apis="apis"
  :identity-id="refundPackDialogIdentityId"
></pack-refund-component>

<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
</template>

